import React from 'react';
import CalculatorTitleUnderline from './CalculatorTitleUnderline';
import { CalculatorTitle, CalculatorTitleHighlight, CalculatorTitleUnderlineWrap } from './styles';

type Props = {
  title: string;
};

const CalculatorTitleContent: React.FC<Props> = ({ title }) => {
  const words = title.trim().split(/\s+/);

  if (words.length < 2) {
    return <CalculatorTitle size="xxlarge">{title}</CalculatorTitle>;
  }

  const leadingWords = words.slice(0, -1).join(' ');
  const lastWord = words[words.length - 1];

  return (
    <CalculatorTitle size="xxlarge">
      {leadingWords}{' '}
      <CalculatorTitleHighlight>
        {lastWord}
        <CalculatorTitleUnderlineWrap>
          <CalculatorTitleUnderline />
        </CalculatorTitleUnderlineWrap>
      </CalculatorTitleHighlight>
    </CalculatorTitle>
  );
};

export default CalculatorTitleContent;
